module.exports = __webpack_public_path__ + "img/image.e4bc9ede.svg";